import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import {Input, Space} from 'antd';
import {useTranslation} from 'react-i18next';
import {StyledAvatarSelect, StyledAvatarSelectDropdownDivider, StyledAvatarSelectDropdownHeader} from './StyledAvatarSelect';

const AvatarSelect = ({
  filteredKey = 'label',
  options = [],
  searchProps = {},
  ...rest
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [t] = useTranslation('main');

  const filteredOptions = useMemo(() => {
    return options.filter(option => option?.[filteredKey]?.toLowerCase().includes(searchValue?.toLowerCase()));
  },[filteredKey, options, searchValue]);

  return (
    <StyledAvatarSelect
      {...rest}
      options={filteredOptions}
      popupRender={menu => (
        <Space size={0} style={{ width: '100%' }} direction='vertical'>
          <StyledAvatarSelectDropdownHeader onClick={e => e.stopPropagation()}>
            <Input
              autoFocus
              placeholder={t('search')}
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              {...searchProps}
            />
          </StyledAvatarSelectDropdownHeader>
          <StyledAvatarSelectDropdownDivider />
          {menu}
        </Space>
      )}
    />
  );
}

AvatarSelect.propTypes = {
  options: PropTypes.array,
};

export default AvatarSelect;
